import {Injectable} from '@angular/core';
import {paymentDataStore} from './payment-data.store';
import {map, Observable} from 'rxjs';
import {
  BillingCycleType,
  ICalculateAutomatedPdfPlan,
  ICalculateEstimateItem,
  ProductType,
} from 'src/app/types/payment.type';
import {MultiSite} from 'src/app/types/site.type';
import {select} from '@ngneat/elf';
import {SubscriptionBillingCycleType} from '../../../../userway/sdk/UserWayApiClient';

@Injectable({providedIn: 'root'})
export class PaymentDataQuery {
  public selectedProduct$: Observable<ProductType>;
  public isSelectedProductAddon$: Observable<boolean>;
  public isTrialActive$: Observable<boolean>;
  public isSwitchingToAnnual$: Observable<boolean>;
  public isSubscriptionOnTrialPeriod$: Observable<boolean>;
  public sites$: Observable<MultiSite[]>;
  public customerId$: Observable<string>;
  public billingCycle$: Observable<BillingCycleType>;
  public estimatedProductData$: Observable<ICalculateEstimateItem[]>;
  public isOnTrialPeriod$: Observable<boolean>;
  public baseDiscountPercentYearly$: Observable<number>;
  public baseDiscountPercentBiAnnual$: Observable<number>;
  public automatedPdfPlan$: Observable<ICalculateAutomatedPdfPlan[]>;
  public isLoading$: Observable<boolean>;

  constructor() {
    this.selectedProduct$ = paymentDataStore.pipe(select(state => state.selectedProduct));
    this.isSelectedProductAddon$ = paymentDataStore.pipe(
      select(state => state.selectedProduct),
      map(
        value =>
          value === ProductType.UsageStats ||
          value === ProductType.ModifyMenu ||
          value === ProductType.LiveTranslations,
      ),
    );
    this.isTrialActive$ = paymentDataStore.pipe(select(state => state.isTrialActive));
    this.isSwitchingToAnnual$ = paymentDataStore.pipe(select(state => state.isSwitchingToAnnual));
    this.isSubscriptionOnTrialPeriod$ = paymentDataStore.pipe(select(state => state.isSubscriptionOnTrialPeriod));
    this.sites$ = paymentDataStore.pipe(select(state => state.sites));
    this.customerId$ = paymentDataStore.pipe(select(state => state.customerId));
    this.billingCycle$ = paymentDataStore.pipe(select(state => state.billingCycle));
    this.estimatedProductData$ = paymentDataStore.pipe(select(state => state.estimatedProductData));
    this.isOnTrialPeriod$ = paymentDataStore.pipe(select(state => state.isOnTrialPeriod));
    this.baseDiscountPercentYearly$ = paymentDataStore.pipe(select(state => state.baseDiscountPercentYearly));
    this.baseDiscountPercentBiAnnual$ = paymentDataStore.pipe(select(state => state.baseDiscountPercentBiAnnual));
    this.automatedPdfPlan$ = paymentDataStore.pipe(select(state => state.automatedPdfPlan));
    this.isLoading$ = paymentDataStore.pipe(select(state => state.isLoading));
  }

  get isPaymentLink() {
    return paymentDataStore.getValue().isPaymentLink;
  }
}
